import { useContext } from "react";
import LoginButton from "./LoginButton";
import LogoutButton from "./LogoutButton";

import PropTypes from "prop-types";

import { userContext } from "src/context/userContext";

export default function LogInOutButton(props) {
  const { isLoggedIn } = useContext(userContext) || {};

  return isLoggedIn ? (
    <LogoutButton noText={props.noText} />
  ) : (
    <LoginButton noText={props.noText} />
  );
}

LogInOutButton.propTypes = {
  noText: PropTypes.bool,
};
